import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import UniversalTracker from './components/UniversalTracker';
import LandingPage from './pages/LandingPage/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import CoursesPage from './pages/CoursesPage';
import CoursesDetallePage from './pages/CoursesDetallePage';
import CursosBouticPage from './pages/CursosBouticPage';
import CursosBouticFundamentosPage from './pages/CursosBouticFundamentosPage';
import EventsPage from './pages/EventsPage';
import EventsDetallePage from './pages/EventsDetallePage';
import NewsletterPage from './pages/NewsletterPage';
import NewsletterDetallePage from './pages/NewsletterDetallePage';
import ShopPage from './pages/ShopPage';
import ShopAsesoriasPage from './pages/ShopAsesoriasPage';
import ItemsDetallePage from './pages/ItemsDetallePage';
import CartPage from './pages/CartPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import MyCoursesPage from './pages/MyCoursesPage';
import CourseCertificatePage from './pages/CourseCertificatePage/CourseCertificatePage';
import MyCourseContentPage from './pages/MyCourseContentPage';
import MyEventsPage from './pages/MyEventsPage';
import MyEventDetailPage from './pages/MyEventDetailPage';
import MyAsesoriasPage from './pages/MyAsesoriasPage';
import MyPurchasesPage from './pages/MyPurchasesPage';
import ClassPlayerPage from './pages/ClassPlayerPage';
import ExamPage from './pages/ExamPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminCourses from './pages/AdminCourses';
import AdminCourseDetail from './pages/AdminCourseDetail';
import AdminUsuariosPage from './pages/AdminUsuariosPage';
import AdminRolesPage from './pages/AdminRolesPage';
import AdminEventosPage from './pages/AdminEventosPage';
import AdminEventosDetallePage from './pages/AdminEventosDetallePage';
import AdminItemsPage from './pages/AdminItemsPage';
import AdminItemDetallePage from './pages/AdminItemDetallePage';
import AdminAsesoriasPage from './pages/AdminAsesoriasPage';
import AdminAsesoriaDetallePage from './pages/AdminAsesoriaDetallePage';
import AdminProfesoresPage from './pages/AdminProfesoresPage';
import AdminProfesorDetallePage from './pages/AdminProfesorDetallePage';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminBundlesPage from './pages/AdminBundlesPage';
import AdminNewsletterPage from './pages/AdminNewsletterPage';
import AdminNewsletterDetallePage from './pages/AdminNewsletterDetallePage';
import AdminMailingPage from './pages/AdminMailingPage';
import AdminPruebasPage from './pages/AdminPruebasPage';
import AdminOrdersPage from './pages/AdminOrdersPage';
import AdminReportsPage from './pages/AdminReportsPage';
import Error401Page from './pages/Error401Page';
import Error403Page from './pages/Error403Page';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage/TermsAndConditionsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage/CookiePolicyPage';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { NotificationProvider } from './context/NotificationContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isErrorPage = location.pathname === '/401' || location.pathname === '/403';

  return (
    <div className="app-shell">
      <Navbar />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:id" element={<CoursesDetallePage />} />
          <Route
            path="/cursos-boutic/fundamentos-ortodoncia-hibrida-alineadores"
            element={<CursosBouticFundamentosPage />}
          />
          <Route path="/cursos-boutic" element={<CursosBouticPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/:id" element={<EventsDetallePage />} />
          <Route path="/newsletters" element={<NewsletterPage />} />
          <Route path="/newsletters/:slug" element={<NewsletterDetallePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/shop/asesorias" element={<ShopAsesoriasPage />} />
          <Route path="/shop/:itemId" element={<ItemsDetallePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
          <Route path="/my-courses" element={<MyCoursesPage />} />
          <Route path="/my-courses/:userId" element={<MyCoursesPage />} />
          <Route path="/my-courses/:courseId/certificate" element={<CourseCertificatePage />} />
          <Route path="/my-courses/:courseId/content" element={<MyCourseContentPage />} />
          <Route path="/my-courses/:courseId/class/:classId" element={<ClassPlayerPage />} />
          <Route path="/my-courses/:courseId/exam/:examId" element={<ExamPage />} />
          <Route path="/my-events" element={<MyEventsPage />} />
          <Route path="/my-events/:eventId" element={<MyEventDetailPage />} />
          <Route path="/my-asesorias" element={<MyAsesoriasPage />} />
          <Route path="/my-purchases" element={<MyPurchasesPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/terminos" element={<TermsAndConditionsPage />} />
          <Route path="/privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/courses/:courseId" element={<AdminCourseDetail />} />
          <Route path="/admin/users" element={<AdminUsuariosPage />} />
          <Route path="/admin/roles" element={<AdminRolesPage />} />
          <Route path="/admin/events" element={<AdminEventosPage />} />
          <Route path="/admin/events/:eventId" element={<AdminEventosDetallePage />} />
          <Route path="/admin/items" element={<AdminItemsPage />} />
          <Route path="/admin/items/:itemId" element={<AdminItemDetallePage />} />
          <Route path="/admin/asesorias" element={<AdminAsesoriasPage />} />
          <Route path="/admin/asesorias/:asesoriaId" element={<AdminAsesoriaDetallePage />} />
          <Route path="/admin/profesores" element={<AdminProfesoresPage />} />
          <Route path="/admin/profesores/:profesorId" element={<AdminProfesorDetallePage />} />
          <Route path="/admin/products" element={<AdminProductsPage />} />
          <Route path="/admin/bundles" element={<AdminBundlesPage />} />
          <Route path="/admin/newsletters" element={<AdminNewsletterPage />} />
          <Route path="/admin/newsletters/:id" element={<AdminNewsletterDetallePage />} />
          <Route path="/admin/mailing" element={<AdminMailingPage />} />
          <Route path="/admin/pruebas" element={<AdminPruebasPage />} />
          <Route path="/admin/orders" element={<AdminOrdersPage />} />
          <Route path="/admin/reports" element={<AdminReportsPage />} />
          <Route path="/401" element={<Error401Page />} />
          <Route path="/403" element={<Error403Page />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </main>
      {!isAdminRoute && !isErrorPage && <Footer />}
      <UniversalTracker />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <NotificationProvider>
          <AppContent />
        </NotificationProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
